
































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsAttributeSticker from "@/design-system/constructs/AttributeSticker/JdsAttributeSticker.vue"
import JdsAttributeListLayout from "@/design-system/constructs/AttributeSticker/JdsAttributeListLayout.vue"
import JdsFieldLayout from "@/design-system/components/Field/JdsFieldLayout.vue"
import JdsAttributeField from "@/design-system/constructs/AttributeSticker/JdsAttributeField.vue"
import JdiDocs from "@/components/JdiDocs.vue"
@Component({
    components: {
        JdiDocs,
        JdsAttributeField,
        JdsFieldLayout, JdsAttributeListLayout, JdsAttributeSticker, JdiPreview, JdiStatus, JdiContent}
})
export default class AttributeSticker extends Vue {
    logDelete() {
        console.log('Attribute sticker deleted -- handle deleting from the list with this event!');
    }
}
